import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const AlignLeft2 = forwardRef(function AlignLeft2(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5H4ZM3.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Zm0 7a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
    </Icon>
  );
});
